// removed by extract-text-webpack-plugin
module.exports = {"applePayButton":"G022b36","applePayButtonText":"G8d06cb","applePayButtonLogo":"Gdfe4e6"};